<template>
  <label :class="`bundle bundle-${color}`">
    {{ $t(`autoinformer.task.status.${value}`) }}
  </label>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      color: function() {
        /* eslint-disable no-unreachable, vue/script-indent */
        switch (this.value) {
          case 'success': {
            return 'green';
          }
          case 'pending': {
            return 'blue';
          }
          case 'processing': {
            return 'fresh';
          }
          case 'deleted': {
            return 'gray';
          }
          case 'fail': {
            return 'error';
          }
          default: {
            return 'default';
          }
        }

        /* eslint-enable */
      }
    }
  };
</script>
